import './index.css'

import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import PrimeVue from 'primevue/config';
import ConfirmationService from 'primevue/confirmationservice'
import Aura from '@primeuix/themes/aura';
import { frappeRequest } from '@frappe-ui/utils/frappeRequest.js'
import { setConfig } from '@frappe-ui/utils/config.ts'
import { configureToast, ToastService } from './services/toast'
import translationPlugin from './translation'
import { initializeTheme } from './composables/theme'

let app = createApp(App)

// Route all frappe-ui resources through Frappe's API client. Besides adding
// the `/api/method` prefix, it sends the CSRF and site headers Frappe expects.
setConfig('resourceFetcher', frappeRequest)

app.use(PrimeVue, {
	theme: {
		preset: Aura,
		options: {
			darkModeSelector: '.app-dark',
		},
	}
})
app.use(ToastService)
app.use(ConfirmationService)
configureToast(app.config.globalProperties.$toast)
app.use(createPinia())
app.use(router)
app.use(i18n)
app.use(translationPlugin)

initializeTheme()
app.mount('#app')
